/* MOTUS: porównywarka modeli (sections/motus-porownanie.liquid, plan 08 zadanie Z1). Rejestr zmian: CUSTOMIZATIONS.md
   - checkbox modelu pokazuje albo chowa jego kolumnę (th i td z tym samym data-col),
   - "Pokaż tylko różnice" chowa wiersze, w których wszystkie widoczne modele mają tę samą wartość,
   - wiersz, w którym wszystkie widoczne modele mają pustą wartość (td[data-empty], "-"), jest zawsze schowany,
   - bez zaznaczonych modeli tabela znika i pokazuje się podpowiedź. Stan startowy renderuje już Liquid (bez migania).
   - lista porównania z karty produktu (przycisk "Porównaj", assets/motus-porownaj.js): ?modele=uchwyt1,uchwyt2 w adresie
     ma pierwszeństwo, potem localStorage (klucz data-storage-key, tablica uchwytów). Zaznaczone zostają tylko te modele,
     reszta się chowa. Bez parametru i bez zapisanej listy = domyślne zaznaczenie z Liquid. Zmiana checkboxa zapisuje listę
     z powrotem (i poprawia ?modele= w adresie, jeśli był), więc karta produktu i porównywarka pokazują to samo. */
class MotusCompare extends HTMLElement {
  connectedCallback() {
    this.toggles = Array.from(this.querySelectorAll('[data-compare-toggle]'));
    this.diffToggle = this.querySelector('[data-compare-diff]');
    this.hint = this.querySelector('[data-compare-empty]');
    this.table = this.querySelector('[data-compare-table]');
    this.rows = Array.from(this.querySelectorAll('[data-compare-row]'));
    this.cells = Array.from(this.querySelectorAll('[data-col]'));
    this.storageKey = this.dataset.storageKey || '';
    this.onChange = (event) => {
      if (!event.target.matches('[data-compare-toggle], [data-compare-diff]')) return;
      this.update();
      if (event.target.matches('[data-compare-toggle]')) this.saveSelection();
    };
    this.addEventListener('change', this.onChange);
    this.applySelection();
    this.update();
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.onChange);
  }

  readStored() {
    if (!this.storageKey) return null;
    try {
      const value = JSON.parse(window.localStorage.getItem(this.storageKey) || 'null');
      return Array.isArray(value) ? value.filter((handle) => typeof handle === 'string') : null;
    } catch (error) {
      return null;
    }
  }

  applySelection() {
    const known = new Set(this.toggles.map((input) => input.dataset.handle).filter(Boolean));
    if (!known.size) return;
    const clean = (list) => list.map((handle) => handle.trim()).filter((handle) => known.has(handle));

    let wanted = null;
    let fromParam = false;
    const param = new URLSearchParams(window.location.search).get('modele');
    if (param) {
      const list = clean(param.split(','));
      if (list.length) {
        wanted = list;
        fromParam = true;
      }
    }
    const stored = this.readStored();
    const storedClean = stored ? clean(stored) : null;
    if (!wanted && storedClean && storedClean.length) wanted = storedClean;
    if (!wanted) {
      // same uchwyty spoza porównywarki (np. model zdjęty z kolekcji): czyścimy listę, zostaje domyślne zaznaczenie
      if (stored && storedClean.length !== stored.length) this.writeStored([]);
      return;
    }

    this.toggles.forEach((input) => {
      input.checked = wanted.includes(input.dataset.handle);
    });
    // lista z adresu staje się listą porównania; z zapisanej listy wypadają uchwyty spoza porównywarki
    const selected = this.selectedHandles();
    if (fromParam || !stored || stored.join(',') !== selected.join(',')) this.saveSelection(false);
  }

  selectedHandles() {
    return this.toggles.filter((input) => input.checked && input.dataset.handle).map((input) => input.dataset.handle);
  }

  writeStored(list) {
    if (!this.storageKey) return;
    try {
      window.localStorage.setItem(this.storageKey, JSON.stringify(list));
    } catch (error) {
      // bez localStorage porównywarka działa jak dotąd, lista żyje tylko w adresie
    }
  }

  saveSelection(updateUrl = true) {
    const list = this.selectedHandles();
    this.writeStored(list);
    if (!updateUrl) return;
    const url = new URL(window.location.href);
    if (!url.searchParams.has('modele')) return;
    if (list.length) {
      url.searchParams.set('modele', list.join(','));
    } else {
      url.searchParams.delete('modele');
    }
    try {
      window.history.replaceState(window.history.state, '', url.pathname + url.search.replace(/%2C/gi, ',') + url.hash);
    } catch (error) {
      // adres zostaje bez zmian
    }
  }

  update() {
    const selected = new Set(this.toggles.filter((input) => input.checked).map((input) => input.value));
    this.cells.forEach((cell) => {
      cell.hidden = !selected.has(cell.dataset.col);
    });

    const onlyDifferences = Boolean(this.diffToggle && this.diffToggle.checked);
    this.rows.forEach((row) => {
      const visible = Array.from(row.querySelectorAll('td[data-col]')).filter((cell) => !cell.hidden);
      // wiersz bez danych u wszystkich pokazanych modeli (same "-") zawsze schowany, niezależnie od "tylko różnice"
      const allEmpty = visible.length > 0 && visible.every((cell) => cell.hasAttribute('data-empty'));
      const values = visible.map((cell) => (cell.dataset.value ?? cell.textContent).replace(/\s+/g, ' ').trim().toLowerCase());
      row.hidden = allEmpty || (onlyDifferences && values.length > 1 && values.every((value) => value === values[0]));
    });

    const empty = selected.size === 0;
    if (this.hint) this.hint.hidden = !empty;
    if (this.table) this.table.hidden = empty;
    this.style.setProperty('--motus-compare-count', String(Math.max(selected.size, 1)));
  }
}

if (!customElements.get('motus-compare')) customElements.define('motus-compare', MotusCompare);
